import { NoImage } from "./NoImage/NoImage";
import { PreviewImage } from "./PreviewImage/PreviewImage";
import { usePreview } from "./usePreview";

export const Preview = () => {
    const { images } = usePreview();

    return (
        <div
            className={`px-4 bg-white dark:bg-darkSurface-100 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 py-4 w-full ${
                images.length === 0 && "h-full"
            } z-0`}
        >
            {images.length > 0 &&
                images.map((image, index) => {
                    return <PreviewImage image={image} key={image.id} index={index} />;
                })}
            {images.length === 0 && (
                <div className="col-span-4" data-testid={`no-image-container`}>
                    <NoImage />
                </div>
            )}

            {images.length > 0 && <div className="py-8"></div>}
        </div>
    );
};
